// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 191 ? "city-data" : chunkId) + "." + {"191":"3f2e336a","455":"c1d0f35a","977":"dd2af882"}[chunkId] + ".chunk.js";
};